export enum PaletteLegendScalingEnum {
  PROPORTIONAL = 'PROPORTIONAL',
  HOMOGENOUS = 'HOMOGENOUS',
}
